import React, { createContext, useState, useEffect, ReactNode } from "react";
import { GlobalService } from "../app/services";

interface EnumsContextType {
  enums: any;
  loading: boolean;
}

export const EnumsContext = createContext<EnumsContextType>({
  enums: {},
  loading: true,
});

interface EnumsProviderProps {
  children: ReactNode;
}

export const EnumsProvider: React.FC<EnumsProviderProps> = ({ children }) => {
  const [enums, setEnums] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  
    const fetchEnums = async () => {
      try {
        const response = await GlobalService.getEnums();
   
        setEnums(response);
      } catch (error) {
        console.error("Failed to fetch enums", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEnums();
  }, []);

  return (
    <EnumsContext.Provider value={{ enums, loading }}>
      {children}
    </EnumsContext.Provider>
  );
};